import { useQuery, UseQueryResult } from 'react-query';
import { SalesPortalPackageList } from 'types';
import { client } from 'utils/api-client';

interface IUseSalesPortalPackagesProps {
  gym?: string;
  search?: string;
  kiloClassId?: string;
  profileId?: string;
}

function useSalesPortalPackages({
  gym,
  search,
  kiloClassId,
  profileId,
}: IUseSalesPortalPackagesProps): UseQueryResult<{ data: Array<SalesPortalPackageList> }> {
  const params = new URLSearchParams();

  if (search) {
    params.append('search', search);
  }

  if (kiloClassId) {
    params.append('kilo_class_id', kiloClassId);
  }

  return useQuery(
    ['salesPortalPackages', gym, search, kiloClassId, profileId],
    () => client.get(`sales-portal/gyms/${gym}/packages/?${params.toString()}`),
    {
      enabled: !!gym,
    },
  );
}

export default useSalesPortalPackages;
